"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "grid grid-cols-1 md:grid-cols-2 gap-5 my-5 sm:my-28 items-stretch" };
const _hoisted_2 = { class: "flex flex-col justify-center items-center" };
const _hoisted_3 = ["src", "srcset", "alt"];
const _hoisted_4 = {
    key: 2,
    class: "mb-5 w-full max-w-md"
};
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = { class: "grid grid-cols-2 gap-0.5 sm:gap-5" };
const _hoisted_7 = { class: "bg-beige-400 rounded-xl flex justify-center items-center p-4 gap-5" };
const _hoisted_8 = ["onClick"];
const _hoisted_9 = ["onClick"];
const _hoisted_10 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "Submit", -1);
const _hoisted_11 = ["onClick"];
const _hoisted_12 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "Continue", -1);
const ProficiencyTest_1 = require("../../stores/ProficiencyTest");
const AudioPlayer_vue_1 = __importDefault(require("../AudioPlayer.vue"));
const ButtonIcon_vue_1 = __importDefault(require("../ButtonIcon.vue"));
const ProficiencyTestAnswer_vue_1 = __importDefault(require("./ProficiencyTestAnswer.vue"));
const VideoPlayer_vue_1 = __importDefault(require("../VideoPlayer.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'ProficiencyTestQuestion',
    props: {
        question: {
            type: Object,
            required: true,
        },
    },
    setup(__props) {
        const props = __props;
        const store = (0, ProficiencyTest_1.useProficiencyTestStore)();
        function dontKnow() {
            store.answerQuestion(0, false);
            store.nextQuestion();
        }
        function submitAnswer() {
            store.answerQuestion(store.currentAnswer.id, store.currentAnswer.correct);
        }
        function nextQuestion() {
            store.nextQuestion();
        }
        return (_ctx, _cache) => {
            var _a, _b, _c;
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                    (0, vue_2.createElementVNode)("div", _hoisted_2, [
                        (__props.question.question_type === 'text' || !__props.question.file)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 0 }, [], 64))
                            : (__props.question.question_type === 'image')
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 1 }, [
                                    (__props.question.file)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("img", {
                                            key: 0,
                                            src: (_a = __props.question.file.urls) === null || _a === void 0 ? void 0 : _a.size_16_9_400,
                                            srcset: `${(_b = __props.question.file.urls) === null || _b === void 0 ? void 0 : _b.size_16_9_400} 400w, ${(_c = __props.question.file.urls) === null || _c === void 0 ? void 0 : _c.size_16_9_800} 800w`,
                                            alt: __props.question.file.alt_text,
                                            class: "w-full max-w-md mb-5 rounded-3xl",
                                            width: "16",
                                            height: "9"
                                        }, null, 8, _hoisted_3))
                                        : (0, vue_2.createCommentVNode)("", true)
                                ], 64))
                                : (__props.question.question_type === 'video')
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_4, [
                                        (0, vue_2.createVNode)(VideoPlayer_vue_1.default, {
                                            class: "w-full h-10 mb-5",
                                            src: __props.question.file.url
                                        }, null, 8, ["src"])
                                    ]))
                                    : (__props.question.question_type === 'audio')
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(AudioPlayer_vue_1.default, {
                                            key: 3,
                                            src: __props.question.file.url,
                                            class: "w-full max-w-md h-10 mb-5"
                                        }, null, 8, ["src"]))
                                        : (0, vue_2.createCommentVNode)("", true),
                        (0, vue_2.createElementVNode)("div", {
                            innerHTML: __props.question.content,
                            class: "text-2xl font-extrabold"
                        }, null, 8, _hoisted_5)
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_6, [
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(__props.question.answers, (answer, index) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(ProficiencyTestAnswer_vue_1.default, {
                                key: index,
                                answer: answer,
                                index: index
                            }, null, 8, ["answer", "index"]));
                        }), 128))
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_7, [
                    (!(0, vue_2.unref)(store).currentAnswer)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                            key: 0,
                            type: "button",
                            onClick: (0, vue_2.withModifiers)(dontKnow, ["prevent"]),
                            class: "button button-outlined button-mutedpurple-800 hover:button-mutedpurple-700"
                        }, " I don't know ", 8, _hoisted_8))
                        : (0, vue_2.createCommentVNode)("", true),
                    ((0, vue_2.unref)(store).currentAnswer && !(0, vue_2.unref)(store).answerSubmitted)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                            key: 1,
                            type: "button",
                            onClick: (0, vue_2.withModifiers)(submitAnswer, ["prevent"]),
                            class: "button button-outlined button-mutedpurple-800 hover:button-mutedpurple-700 has-icon"
                        }, [
                            (0, vue_2.createVNode)(ButtonIcon_vue_1.default),
                            _hoisted_10
                        ], 8, _hoisted_9))
                        : (0, vue_2.createCommentVNode)("", true),
                    ((0, vue_2.unref)(store).answerSubmitted)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                            key: 2,
                            type: "button",
                            onClick: (0, vue_2.withModifiers)(nextQuestion, ["prevent"]),
                            class: "button button-outlined button-mutedpurple-800 hover:button-mutedpurple-700 has-icon"
                        }, [
                            (0, vue_2.createVNode)(ButtonIcon_vue_1.default),
                            _hoisted_12
                        ], 8, _hoisted_11))
                        : (0, vue_2.createCommentVNode)("", true)
                ])
            ], 64));
        };
    }
});
